export const PARAM_KEY_HORIZONTAL_SIGNING = "horizontalSigning"
export const HORIZONTAL_SIGNING_CODE_URL_PARAM = "horizontalSigningType"
export const HORIZONTAL_SIGNING_CONDITION_URL_PARAM = "horizontalSigningCondition"
export const HORIZONTAL_SIGNING_TAGS_URL_PARAM = "horizontalSigningTags"